export const FEATURE_FLAG_API_SDK_KEY_DEVELOPMENT = '683713ad96e9af0a5f819b96';
export const FEATURE_FLAG_API_SDK_KEY_PRODUCTION = '683713ad96e9af0a5f819b97';
export const FEATURE_FLAG_API_SDK_KEY_STAGING = '68a737f3f8ca7f099445e729';
